import Accessory from './model-accessory';

/**
 * defa.collections.Accessory
 * A description.
 * @version 0.1
 */

const Accessories = Bb.Collection.extend( {
	model: Accessory,
} );

export default Accessories;